export default __webpack_public_path__ + "static/media/Pistol_9.d39732b9.png";